import * as I18n from 'circe/I18n';
import { NAME as APP_NAME } from 'domain/operations/constants';
import moment from 'moment';
import { getFleetByName } from 'domain/fleets/apis';
import { getCouriers } from 'domain/tap/apis';
import { filterVehicleTypes } from 'domain/vehicle/utils';
import { getOptions } from 'domain/fuse/models/model';

export const NAME = `${APP_NAME}/DRIVER`;
export const LISTING_ENDPOINT = `${OPERATIONS_EDGE}/api/drivers`;
export const TRIPS_LISTING_ENDPOINT = `${OPERATIONS_EDGE}/api/itineraries/query`;
export const RESET_PASSWORD_URL = `${AUTH_EDGE}/public-api/user-admin/<%= userId %>/pw/reset-by-admin`;
export const CREATE_NEW_PROFILE_FORM_NAME = 'CREATE_NEW_PROFILE';
export const namespace = 'DRIVER_BROKER';

export const REDUCER_NAME = 'drivers';

export const DRIVER_STATUS = {
  ACTIVE: I18n.str('ACTIVE', 'ACTIVE'),
  INACTIVE: I18n.str('inactive', 'Inactive'),
  DEACTIVATED: I18n.str('deactivated', 'Deactivated'),
  PENDING_ACTIVATION: I18n.str('PENDING_ACTIVATION', 'PENDING_ACTIVATION'),
  SUSPENDED: I18n.str('SUSPENDED', 'SUSPENDED'),
  PENDING_USER_ACTION: I18n.str('PENDING_USER_ACTION', 'PENDING_USER_ACTION'),
};

export const STATUSES = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  DEACTIVATED: 'DEACTIVATED',
  PENDING_ACTIVATION: 'PENDING_ACTIVATION',
  SUSPENDED: 'SUSPENDED',
  PENDING_USER_ACTION: 'PENDING_USER_ACTION',
};

export const DRIVER_STATUS_LABEL = {
  ACTIVE: I18n.str('ACTIVE', 'Active'),
  INACTIVE: I18n.str('inactive', 'Inactive'),
  DEACTIVATED: I18n.str('deactivated', 'Deactivated'),
  PENDING_ACTIVATION: I18n.str('PENDING_ACTIVATION', 'Pending Activation'),
  SUSPENDED: I18n.str('SUSPENDED', 'Suspeneded'),
  PENDING_USER_ACTION: I18n.str('PENDING_USER_ACTION', 'Pending User Action'),
};

export const DRIVER_WORKING_STATUS = {
  IN_ACTION: I18n.str('driving', 'Driving'),
  SNEEZING: I18n.str('sneezing', 'Snoozed'),
  AVAILABLE: I18n.str('canPickup', 'Can pick up'),
};

export const ROUTES = {
  ROOT: '/drivers',
};

export const VehicleDefaults = [
  {
    value: 'BULKER',
    axles: 2,
    capacity_height: 2.5,
    capacity_length: 13.5,
    capacity_width: 2.5,
    height: 4,
    label: 'Bulker',
    length: 22,
    max_trailers: 0,
    max_weight: 35000,
    starting_weight: 7000,
    tare_weight: 5500,
    width: 2.4,
    temp_range: '',
  },
  {
    value: 'FLAT_BED',
    axles: 2,
    capacity_height: 2.6,
    capacity_length: 13.6,
    capacity_width: 2.6,
    height: 4,
    label: 'Flat Bed',
    length: 22,
    max_trailers: 0,
    max_weight: 35000,
    starting_weight: 30000,
    tare_weight: 5500,
    width: 2.4,
    temp_range: '',
  },
];

export const DATES = {
  YESTERDAY: {
    start: moment().subtract(1, 'days'),
    end: moment().subtract(1, 'days'),
  },
  TODAY: {
    start: moment(),
    end: moment(),
  },
  LASTDAY: {
    start: moment().subtract(1, 'day'),
    end: moment().subtract(1, 'day'),
  },
  LASTWEEK: {
    start: moment().subtract(1, 'week'),
    end: moment(),
  },
  LAST30DAY: {
    start: moment().subtract(1, 'month'),
    end: moment(),
  },
};

export const TAGS = [
  { name: I18n.str('grayCement', 'Gray Cement'), value: 'division:cement' },
  {
    name: I18n.str('whiteCement', 'White Cement'),
    value: 'division:white cement',
  },
  { name: I18n.str('masheedGate', 'Masheed Gate'), value: 'division:gate' },
  {
    name: I18n.str('masheedGateCement', 'Masheed Gate Cement'),
    value: 'gate:cement',
  },
  {
    name: I18n.str('cementReplacement', 'Cement Replacement'),
    value: 'division:cement replacement',
  },
];

export const showLicencePlateColumn = false;
export const disableLicencePlateFilter = true;
export const showAvailabilityColumn = false;

export const TEMP_CLASSIFICATIONS = ['TC', 'DRY', 'FROZEN'];

export const nameColumnWidth = 280;
export const tagsColumnWidth = 180;

export const DRIVERS_CLASSIFICATION = 'DRIVERS';

export const SHOWN_FILTERS = () => [
  {
    name: I18n.str('name', 'Name'),
    type: 'Textfield',
    accessor: 'name',
    placeholder: I18n.str('enterDriverName', 'Enter Driver Name'),
  },
  {
    name: I18n.str('phone', 'Phone'),
    type: 'Textfield',
    accessor: 'phone',
  },
];

export const HIDDEN_FILTERS = (vehicleTypes, baseCities) => [
  {
    name: I18n.str('licensePlate', 'License Plate'),
    type: 'Textfield',
    accessor: 'vehicleLicensePlate',
    masked: true,
    placeholder: I18n.str('licensePlatePlaceHolder', 'e.g. 1234 A B C'),
  },
  {
    name: I18n.str('driverId', 'Driver Id'),
    type: 'Textfield',
    accessor: 'refId',
  },
  {
    name: I18n.str('company', 'Company'),
    type: 'Autocomplete',
    accessor: 'aid',
    optionName: 'company',
    api: true,
    getOptions: getCouriers,
  },
  {
    name: I18n.str('vehicle', 'Vehicle'),
    type: 'Autocomplete',
    accessor: 'vehicleType',
    optionName: 'vehicle',

    api: false,
    options: filterVehicleTypes(vehicleTypes),
  },
  {
    name: I18n.str('baseCity', 'Base City'),
    type: 'Autocomplete',
    accessor: 'baseCity',
    optionName: 'base',
    api: false,
    options: getOptions(baseCities),
  },
];

export const PAGE_NAME = 'drivers';
